import { useContext } from 'react';
import { OptimizelyDecideOption as optimizelyOptions } from '@optimizely/optimizely-sdk';
import OptimizelyContext from './OptimizelyContext';
import getOptimizelyInstance from './getOptimizelyInstance';
const getOptimizelyDecision = ({
  context,
  featureKey
}) => {
  const {
    disabled,
    forcedExperiments = [],
    forcedFeatures = {},
    userInstance = {}
  } = context;

  // Bail if no featureKey was passed to avoid appearing to work.
  if (!featureKey) {
    return null;
  }
  if (disabled) {
    return [false, {}];
  }
  let decideOptions = typeof window === 'undefined' ? [optimizelyOptions.DISABLE_DECISION_EVENT] : null;
  if (forcedExperiments.includes('na')) {
    decideOptions = [optimizelyOptions.DISABLE_DECISION_EVENT];
  }
  const {
    enabled,
    variables = {}
  } = userInstance.decide(featureKey, decideOptions);
  if (forcedFeatures[featureKey]) {
    return [true, {
      ...variables,
      ...forcedFeatures[featureKey]
    }];
  }
  if (forcedFeatures[featureKey] !== undefined) {
    return [false, {}];
  }
  return [enabled, variables];
};

/**
 * Usage:
 * const [ enabled, variables ] = useOptimizelyFeature('NAME_OF_FEATURE');
 */
const useOptimizelyFeature = featureKey => {
  const context = useContext(OptimizelyContext);
  const optimizelyInstance = getOptimizelyInstance() || {};
  const {
    featuresMap = {}
  } = typeof optimizelyInstance.getOptimizelyConfig === 'function' ? optimizelyInstance.getOptimizelyConfig() : {};
  if (featureKey) {
    return getOptimizelyDecision({
      context,
      featureKey,
      optimizelyInstance
    });
  }
  return {
    getDecision: key => getOptimizelyDecision({
      context,
      featureKey: key
    }),
    getUserInfo: () => context?.user || {},
    isValidFeature: key => !!featuresMap[key],
    getForcedFeatures: () => context?.forcedFeatures || {}
  };
};
export default useOptimizelyFeature;